import React from 'react'
import { ModalSeeker } from '@ui-seeker/core'
import { isOpenGroupingExportsModal } from 'Pages/ReportsAlerts/ExportsGrouping/@signals'
import GroupingExportsModalContent from 'Pages/ReportsAlerts/ExportsGrouping/Modal/Content'


export default function GroupingExportsModal() {


	return <ModalSeeker
		isOpen={!!isOpenGroupingExportsModal.value}
		controller={() => isOpenGroupingExportsModal.value = null}
		hideActions
	>
		<GroupingExportsModalContent/>
	</ModalSeeker>
}